import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { Trustee, TrusteePayload } from "@project/types/trustee";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/trustees`;
const SILENT: RequestConfig = { showNotification: false };

class TrusteeService {
  listTrusteesPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<Trustee>> => {
    return fetchListPage<Trustee>(`${BASE}/`, query);
  };

  getTrustee = async (id: number): Promise<Trustee | undefined> => {
    const data = await get<ApiItemResponse<Trustee> | Trustee>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  createTrustee = async (
    payload: TrusteePayload
  ): Promise<Trustee | undefined> => {
    const data = await post<ApiItemResponse<Trustee> | Trustee, TrusteePayload>(
      `${BASE}/`,
      payload,
      SILENT
    );
    return unwrapItem(data);
  };

  updateTrustee = async (
    id: number,
    payload: Partial<TrusteePayload>
  ): Promise<Trustee | undefined> => {
    const data = await patch<
      ApiItemResponse<Trustee> | Trustee,
      Partial<TrusteePayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  deleteTrustee = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const trusteeService = new TrusteeService();
